import React from 'react'
import { Link } from "react-router-dom";
import { hrApplications, settingsDriverSchedules, settingsDriverSchedulesDrivers, resrvationsExpenseTickets, hrVendors } from '../../../routesConfiguration/paths';
import ApplicationsIcon from '../../icons/applications-icon';
import DriverScheduleIcon from '../../icons/schedule-icon';
import DriverIcon from '../../icons/driverIcon';
import ExpenseFormIcon from '../../icons/expense-form-icon';

export const HrMenu = () => {
    return (
        <div className="d-flex flex-wrap justify-content-center">
            <div className="col-12 col-xl-10 d-flex flex-wrap">
                <div className="col-6 col-md-4 col-xl-3 py-2 py-md-4 px-0 px-md-3">
                    <Link to={hrApplications}
                        style={{ borderWidth: '2px', borderStyle: 'solid', borderColor: '#707070', color: '#000', maxWidth: '200px' }}
                        className="border border-dark rounded shadow text-decoration-none navCrewOption m-3 py-4 px-3 d-flex flex-column justify-content-center align-items-center hover-primary"
                    >
                        <div style={{ height: '2.5rem' }}>
                            <ApplicationsIcon className="h-100" />
                        </div>
                        <span className="mt-3">Applications</span>
                    </Link>
                </div>
                <div className="col-6 col-md-4 col-xl-3 py-2 py-md-4 px-0 px-md-3">
                    <Link to={settingsDriverSchedules}
                        style={{ borderWidth: '2px', borderStyle: 'solid', borderColor: '#707070', color: '#000', maxWidth: '200px' }}
                        className="border border-dark rounded shadow text-decoration-none navCrewOption m-3 py-4 px-3 d-flex flex-column justify-content-center align-items-center hover-primary"
                    >
                        <div style={{ height: '2.5rem' }}>
                            <DriverScheduleIcon className="h-100" />
                        </div>
                        <span className="mt-3">Driver Schedules</span>
                    </Link>
                </div>
                <div className="col-6 col-md-4 col-xl-3 py-2 py-md-4 px-0 px-md-3">
                    <Link to={settingsDriverSchedulesDrivers}
                        style={{ borderWidth: '2px', borderStyle: 'solid', borderColor: '#707070', color: '#000', maxWidth: '200px' }}
                        className="border border-dark rounded shadow text-decoration-none navCrewOption m-3 py-4 px-3 d-flex flex-column justify-content-center align-items-center hover-primary"
                    >
                        <div style={{ height: '2.5rem' }}>
                            <DriverIcon className="h-100" />
                        </div>
                        <span className="mt-3">Drivers</span>
                    </Link>
                </div>
                <div className="col-6 col-md-4 col-xl-3 py-2 py-md-4 px-0 px-md-3">
                    <Link to={resrvationsExpenseTickets}
                        style={{ borderWidth: '2px', borderStyle: 'solid', borderColor: '#707070', color: '#000', maxWidth: '200px' }}
                        className="border border-dark rounded shadow text-decoration-none navCrewOption m-3 py-4 px-3 d-flex flex-column justify-content-center align-items-center hover-primary"
                    >
                        <div style={{ height: '2.5rem' }}>
                            <ExpenseFormIcon className="h-100" />
                        </div>
                        <span className="mt-3">Expense Forms</span>
                    </Link>
                </div>
                <div className="col-6 col-md-4 col-xl-3 py-2 py-md-4 px-0 px-md-3">
                    <Link to={hrVendors}
                        style={{ borderWidth: '2px', borderStyle: 'solid', borderColor: '#707070', color: '#000', maxWidth: '200px' }}
                        className="border border-dark rounded shadow text-decoration-none navCrewOption m-3 py-4 px-3 d-flex flex-column justify-content-center align-items-center hover-primary"
                    >
                        <div style={{ height: '2.5rem' }}>
                            <i className="fa fa-building"></i>
                        </div>
                        <span className="mt-3">Vendors</span>
                    </Link>
                </div>
            </div>
        </div>
    )
}


